<div class="quick-actions-container" *ngIf="hasVisibleActions">
  <h2 class="quick-actions-title">Quick Actions</h2>
  <div class="quick-actions-grid">
    <button 
      *ngFor="let action of quickActions" 
      mat-raised-button
      class="quick-action-button"
      [ngClass]="'action-' + action.color"
      (click)="executeAction(action)">
      <mat-icon class="action-icon">{{ action.icon }}</mat-icon>
      <span class="action-label">{{ action.label }}</span>
    </button>
  </div>
</div>
